<script>
import { Bar, mixins } from 'vue-chartjs';

export default {
  extends: Bar,
  props: ['chartdata'],
  data() {
    return {
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        title: {
          display: true,
          text: '최근 7일 방문자 현황',
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  methods: {},
  async mounted() {
    this.renderChart(this.chartdata, this.options);
  },
};
</script>
